import PlayButton from '../../src/legacy/PlayButton';
export default PlayButton;
